import PropTypes from "prop-types";
import React from "react";

import { window } from "@swa-ui/browser";
import { Button } from "@swa-ui/core";
import { useSSOLogin } from "@swa-ui/inflight";

import styles from "./AccountLoginCallToActionCommand.module.scss";

export const AccountLoginCallToActionCommand = (props) => {
  const { children, newWindow, role, styleType, targetProps } = props;
  const { getSSOLoginUrl } = useSSOLogin();

  return (
    <div className={styles.loginCommand}>
      <Button {...getAccountLoginButtonProps()}>
        <div>
          <span>{children}</span>
        </div>
      </Button>
    </div>
  );

  function getAccountLoginButtonProps() {
    return {
      "aria-label": props["aria-label"],
      className: styles.loginButton,
      fullWidth: true,
      newWindow,
      onClick: handleAccountLoginButtonClick,
      role,
      styleType,
    };
  }

  async function handleAccountLoginButtonClick() {
    const url = await getSSOLoginUrl(targetProps);

    if (newWindow) {
      window.open(url, "_blank");
    } else {
      window.location.href = url;
    }
  }
};

AccountLoginCallToActionCommand.propTypes = {
  /** aria-label text to provide accessibility description for button. */
  "aria-label": PropTypes.string,

  /** child node to render within the Button component. */
  children: PropTypes.node,

  /** role of the Button to provide accessibility. */
  role: PropTypes.string,

  /** style type for the button. */
  styleType: PropTypes.string,

  /** additional props to be sent to useSSOLogin. */
  targetProps: PropTypes.object,
};
